import React, { useContext } from 'react';
import classNames from 'classnames';
import MembersImage from 'assets/images/members.webp';
import ResolveImage from 'components/ResolveImage';
import { useTranslation } from 'react-i18next';
import FaqContext from '../../providers/Faq/Faq.context';
import PluscircleIcon from 'icons/Pluscircle.icon';
import { Button } from 'ncoded-component-library';

import './FaqEmpty.styles.scss';

type FaqEmptyProps = {
  className?: string;
};

const FaqEmpty: React.FC<FaqEmptyProps> = (props) => {
  const { className } = props;
  const { t } = useTranslation();
  const { canUserAddFAQ, openFAQ } = useContext(FaqContext);

  const classes = classNames('faq-empty', className);

  return (
    <div className={classes}>
      <ResolveImage src={MembersImage} asIllustration />
      <p>{t('noFaqsPublishedYet')}</p>
      <p>{t('noFqsDesc1')}</p>
      <p>{t('noFqsDesc2')}</p>
      {canUserAddFAQ && (
        <Button variant="outline" icon={PluscircleIcon} onClick={openFAQ}>
          {t('addAnFAQ')}
        </Button>
      )}
    </div>
  );
};

export default FaqEmpty;
